<template>
  <div class="m-b-16">
    <!--------委托项目---------->
    <div v-if="orderInfo.projectId" class="card">
      <div class="section">
        <div class="section-title">
          <base-section-title title="委托项目" />
        </div>
        <div class="section-content">
          <jczh-descriptions
            :info="projectInfo"
            :option="projectOption"
            :el-attrs="{
              size: 'medium',
              column: 2,
              labelStyle: {
                whiteSpace: 'nowrap'
              }
            }"
          >
            <template v-slot:attachmentGroupId>
              <upload
                v-if="projectInfo.attachmentGroupId"
                :props-data="{
                  groupIdBefore: projectInfo.attachmentGroupId,
                  disabled: true
                }"
              />
              <span v-else>-</span>
            </template>
          </jczh-descriptions>
        </div>
      </div>
    </div>

    <!---------招标信息-------------->
    <div class="card">
      <div class="section">
        <div class="section-title">
          <base-section-title title="招标信息" />
        </div>
        <div class="section-content">
          <jczh-descriptions
            :info="orderInfo"
            :option="biddingInfoOption"
            :el-attrs="{
              size: 'medium',
              column: 2,
              labelStyle: {
                whiteSpace: 'nowrap'
              }
            }"
          >
            <template v-slot:budget>
              <span>
                {{ orderInfo.budget ? strToThousands(orderInfo.budget) : '-' }}
                万元
              </span>
              <money-in-cn :money="orderInfo.budget * 10000" />
            </template>
          </jczh-descriptions>
        </div>
      </div>
    </div>

    <!----------招标方式-------------->
    <div class="card">
      <div class="section">
        <div class="section-title">
          <base-section-title title="招标方式" />
        </div>
        <div class="section-content">
          <jczh-descriptions
            :info="orderInfo"
            :option="biddingMethodOption"
            :el-attrs="{
              size: 'medium',
              column: 2,
              labelStyle: {
                whiteSpace: 'nowrap'
              }
            }"
          >
            <template v-slot:otherRequire="{ value }">
              <other-material-requirements :table="value || []" mode="detail" />
            </template>
            <template v-slot:inviteSupNormal>
              <select-bid-supplier-controller
                v-model="orderInfo.inviteSup"
                style="width: 700px"
                :read-only="true"
                table-key="supplierId"
                :is-combo="isCombo"
                :normalize-in="normalizeIn"
                :normalize-out="normalizeOut"
              />
            </template>
            <template v-slot:supplierCategoryList>
              <div v-if="supplierCategoryList.length">
                <select-group-supplier
                  v-model="supplierCategoryList"
                  :normalize-in="normalizeInGroup"
                  :read-only="true"
                />
              </div>
              <span v-else>-</span>
            </template>
            <template v-slot:internalAttachments>
              <upload
                v-if="orderInfo.internalAttachments"
                :file-id-before="orderInfo.internalAttachments"
                :props-data="{
                  disabled: true,
                  uploadMode: 'fileId'
                }"
              />
              <span v-else>-</span>
            </template>
          </jczh-descriptions>
        </div>
      </div>
    </div>

    <!----------招标文件------------>
    <div class="card">
      <div class="section">
        <div class="section-title">
          <base-section-title title="招标文件" />
        </div>
        <div class="section-content">
          <jczh-descriptions
            :info="orderInfo"
            :option="bidFileInfoOption"
            :el-attrs="{
              size: 'medium',
              column: 2,
              labelStyle: {
                whiteSpace: 'nowrap'
              }
            }"
          >
            <template v-slot:bookFee="{ value }">
              <span>{{ value ? `${strToThousands(value)} 元` : '-' }}</span>
              <money-in-cn v-if="value" :money="value" />
            </template>
            <!-- 平台使用费 -->
            <template v-slot:platformFee="{ value }">
              <span>{{ value ? `${strToThousands(value)} 元` : '-' }}</span>
              <money-in-cn v-if="value" class="m-l-4" :money="value" />
            </template>
            <template v-slot:biddingAttachmentIds>
              <upload-authorization-file
                v-if="orderInfo.biddingAttachmentIds"
                ref="uploadBiddingFile"
                v-model="orderInfo.biddingAttachmentIds"
                class="upload"
                upload-mode="fileId"
                :preview-api="previewBiddingFileApi"
                :download-api="downloadBiddingFileApi"
                :request-params="{
                  isRelease: true,
                  orderId: orderId,
                  fileType: fileTypeDict.BID.value
                }"
                :props-data="{
                  disabled: true
                }"
              />
              <span v-else>-</span>
            </template>
            <template v-slot:otherAttachment>
              <upload-authorization-file
                v-if="orderInfo.otherAttachmentIds"
                ref="uploadBiddingFile"
                v-model="orderInfo.otherAttachmentIds"
                class="upload"
                upload-mode="fileId"
                :preview-api="previewBiddingFileApi"
                :download-api="downloadBiddingFileApi"
                :request-params="{
                  isRelease: true,
                  orderId: orderId,
                  fileType: fileTypeDict.OTHER.value
                }"
                :props-data="{
                  disabled: true
                }"
              />
              <span v-else>-</span>
            </template>
          </jczh-descriptions>
          <!---电子化开评标详情----->
          <bid-online-detail
            v-if="isKpbProject"
            class="online-file_inbox"
            :kpb-file-id="kpbFileId"
            :order-id="orderId"
            :is-release="true"
          />
        </div>
      </div>
    </div>

    <!----------招标公告-------------->
    <div class="card">
      <div class="section">
        <div class="section-title">
          <base-section-title title="公告" />
        </div>
        <div class="section-content">
          <jczh-descriptions
            :info="orderInfo"
            :option="biddingNoticeOption"
            :el-attrs="{
              size: 'medium',
              column: 2,
              labelStyle: {
                whiteSpace: 'nowrap'
              }
            }"
          />
          <section class="notice-section">
            <h5>{{ orderInfo.title }}</h5>
            <u-editor v-model="orderInfo.content" disabled />
          </section>
        </div>
      </div>
    </div>

    <!------保证金设置---------->
    <div class="card">
      <div class="section">
        <div class="section-title">
          <base-section-title title="保证金设置" />
        </div>
        <div class="section-content">
          <jczh-descriptions
            :info="bondInfo"
            :option="bondInfoOptions"
            :el-attrs="{
              size: 'medium',
              column: 3,
              labelStyle: {
                whiteSpace: 'nowrap'
              }
            }"
          >
            <template v-slot:guaranteeFee="{ value }">
              <span>{{ value ? strToThousands(value) : '-' }}</span>
              <money-in-cn v-if="value" :money="value" />
            </template>
          </jczh-descriptions>
        </div>
      </div>
    </div>

    <!-- 审批备注 -->
    <record-remark
      v-if="requestQuery.pageFrom == 'auditDetail'"
      :remark-list="remarkList"
    />

    <!-- 审批历史 -->
    <record-history
      v-if="requestQuery.pageFrom == 'auditDetail'"
      :record-list="orderInfo.flowListing"
    />
  </div>
</template>

<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import UploadAuthorizationFile from '@/components/common/Upload/UploadAuthorizationFile'
import SelectGroupSupplier from '@/components/common/SelectSupplierDrawer/SelectGroupSupplier.vue'
import MoneyInCn from '@/components/common/MoneyInCn'
import OtherMaterialRequirements from '@/components/common/OtherMaterialRequirements/OtherMaterialRequirements'
import Upload from '@/components/common/Upload/index.vue'
import UEditor from '@/components/common/UEditor/index.vue'
import SelectBidSupplierController from '@/components/common/SelectSupplierDrawer/SelectBidSupplierController'
import BidOnlineDetail from '@/components/kpb/project/BidOnlineDetail.vue'
import RecordHistory from '@/components/common/RecordHistory'
import RecordRemark from '@/components/common/RecordRemark'

// 数据字典
import {
  bidWinWayDict,
  bidInviteWayDict,
  bidRegisterAuditFlagDict,
  bidPublishWayDict,
  isComboDict,
  needBidBondDict,
  bondBidTypeDict,
  uploadBiddingFileTypeDict,
  bookFeeFreeRangeDict,
  bidChargeStatusDict,
  bidInviteBidStatusDict,
  fileTypeDict
} from '@/dictionary/project/bid'
import {
  projectOpenScopeDict,
  projectTypeDict,
  releaseMediaDict,
  whetherDict,
  isSignupShowListingDict,
  projectAssetDisposalMethodDict,
  offerTypeDict
} from '@/dictionary/project/common'

import {
  fetchInviteBidDetailApi,
  previewBiddingFileApi,
  downloadBiddingFileApi
} from '@/api/procure/invite-bid'
import { getEntrustInfoByOrderIdApi } from '@/api/procure/entrust'

import { strToThousands } from '@/utils/utils'
import DateUtils from '@/utils/date'
import { mapState } from 'vuex'
import { workbenchServiceDict } from '@/dictionary/system'

export default {
  components: {
    BaseSectionTitle,
    UploadAuthorizationFile,
    SelectGroupSupplier,
    MoneyInCn,
    OtherMaterialRequirements,
    Upload,
    UEditor,
    SelectBidSupplierController,
    BidOnlineDetail,
    RecordHistory,
    RecordRemark
  },

  props: {
    isByOrderId: {
      type: Boolean,
      default: true
    },

    requestQuery: {
      type: Object,
      default: () => {}
    },

    // 备注列表
    remarkList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  data() {
    return {
      fileTypeDict,
      bookFeeFreeRangeDict,
      bidChargeStatusDict,
      bidInviteBidStatusDict,
      bidPublishWayDict,
      isSignupShowListingDict,

      previewBiddingFileApi,
      downloadBiddingFileApi,

      platformFeeVisible: false,

      orderId: '',
      biddingFileAttachmentGroupId: '',
      projectInfo: {},
      orderInfo: {},
      inviteSupNormal: [], // 初始邀请的供应商
      bondInfo: {} // 保证金设置
    }
  },

  computed: {
    ...mapState('router', ['currentWorkbench']),

    // 是否是代理机构操作
    isAgency() {
      return this.currentWorkbench === workbenchServiceDict.AGENCY.value
    },

    // 招标文件id
    kpbFileId() {
      return this.orderInfo?.biddingFileId || 0
    },
    // 是否联合体报名
    isCombo: {
      get() {
        return !!this.orderInfo.isCombo
      },
      set(val) {
        this.orderInfo.isCombo = val
          ? isComboDict.YES.value
          : isComboDict.NO.value
      }
    },
    // 是否是公开招标
    inPublicBid() {
      return (
        this.orderInfo.releaseMethod === bidPublishWayDict.NOTICE_BIDDING.value
      )
    },
    // 是否需要审核
    isNeedApproval() {
      return this.orderInfo.isApproval === bidRegisterAuditFlagDict.YES.value
    },
    // 是否是线上开评标项目
    isKpbProject() {
      return this.orderInfo.isKpbProject === whetherDict.YES.value
    },

    // 已选公开范围
    supplierCategoryList() {
      return this.orderInfo.orderSupplierCategoryList || []
    },

    // 是否是招商
    isMerchant() {
      return this.orderInfo.isMerchant
    },

    // 招标名称
    bidCopyWriting() {
      if (this.isMerchant) return { name: '招商', fullName: '招商引资' }
      return { name: '招标', fullName: '招标采购' }
    },

    // 委托项目信息
    projectOption() {
      return [
        {
          label: '项目名称',
          prop: 'projectName',
          elAttrs: {
            span: 2
          }
        },
        {
          label: '委托方',
          prop: 'purchaseCompanyName'
        },
        {
          label: '负责人',
          prop: 'purchaseLink',
          filter: value =>
            `${this.projectInfo.purchaseLink} ${this.projectInfo.linkTelephone}`
        },
        {
          label: '项目编号',
          prop: 'projectCode'
        },
        {
          label: '项目概算(万元)',
          prop: 'budget',
          filter: value => (value ? `${strToThousands(value)}` : '-')
        },
        {
          label: '项目类型',
          prop: 'projectType',
          filter: value => projectTypeDict.translate(value).label || '-'
        },
        {
          label: '项目地点',
          prop: 'province',
          filter: () =>
            this.projectInfo.province
              ? `${this.projectInfo.province} - ${this.projectInfo.city} - ${this.projectInfo.area}`
              : '-'
        },
        {
          label: '详细地址',
          prop: 'address',
          filter: () =>
            this.projectInfo.country !== '中国'
              ? this.projectInfo.foreignAddress
              : this.projectInfo.address,
          elAttrs: {
            span: 2
          }
        },
        {
          label: '附件',
          prop: 'attachmentGroupId',
          slotName: 'attachmentGroupId',
          elAttrs: {
            span: 2
          }
        }
      ]
    },
    // 招标基础信息
    biddingInfoOption() {
      return [
        {
          label: '招标名称',
          prop: 'orderName',
          elAttrs: {
            span: 2
          }
        },
        {
          label: '招标估算',
          prop: 'budget',
          // filter: value => `${value} 万元`,
          slotName: 'budget'
        },
        {
          label: '中标方式',
          prop: 'winType',
          filter: value => bidWinWayDict.translate(value).label
        },
        {
          label: '报价方式',
          prop: 'offerType',
          filter: value => offerTypeDict.translate(value).label
        },
        {
          label: '报名时间',
          prop: '',
          filter: value => {
            return DateUtils.getNormMinuteRange(
              value.signUpStartTime,
              value.signUpEndTime
            )
          },
          elAttrs: {
            labelClassName: 'text-danger',
            contentClassName: 'text-danger'
          }
        },
        {
          label: '开标时间',
          prop: 'openTime',
          elAttrs: {
            labelClassName: 'text-danger',
            contentClassName: 'text-danger'
          },
          isNormMinute: true
        },
        {
          label: '项目类型',
          prop: 'biddingType',
          filter: value => projectTypeDict.translate(value).label
        },
        {
          label: '处置方式',
          prop: 'assetDisposalMethod',
          filter: value =>
            projectAssetDisposalMethodDict.translate(value)?.label ||
            projectAssetDisposalMethodDict.EXPENDITURE.label,
          hideFun: () =>
            this.orderInfo.biddingType !== projectTypeDict.ASSET_DISPOSAL.value
        },
        {
          label: '发布媒体',
          prop: 'noticeMedium',
          filter: value => {
            const temp = (value || '').split(',')
            return (
              temp
                .map(mediumValue => {
                  return releaseMediaDict.translate(mediumValue)?.label
                })
                .filter(value => value)
                .join('、') || '-'
            )
          },
          elAttrs: {
            labelClassName: this.isKpbProject ? 'text-danger' : '',
            contentClassName: this.isKpbProject ? 'text-danger' : ''
          }
        },
        {
          label: '招标地点',
          filter: value => {
            if (value?.country === '中国') {
              return `${value?.province} - ${value?.city} - ${value?.area}`
            } else {
              return `${value?.country} - ${value?.foreignAddress}`
            }
          }
        },
        {
          label: '详细地址',
          prop: 'detailAddress'
        }
      ]
    },

    // 招标方式
    biddingMethodOption() {
      return [
        {
          label: '招标方式',
          prop: 'biddingMethod',
          filter: value =>
            bidInviteWayDict
              .translate(value)
              ?.label?.replace(/招标/, this.bidCopyWriting.name),
          elAttrs: {
            labelClassName: 'text-danger',
            contentClassName: 'text-danger'
          }
        },
        {
          label: '发布方式',
          prop: 'releaseMethod',
          filter: value =>
            bidPublishWayDict
              .translate(value)
              ?.label?.replace(/招标/, this.bidCopyWriting.name)
        },
        {
          label: '公开范围',
          prop: 'openScope',
          dictArray: projectOpenScopeDict.array,
          hideFun: () => !this.inPublicBid,
          elAttrs: {
            span: 2
          }
        },
        {
          label: '已选公开范围',
          slotName: 'supplierCategoryList',
          hideFun: value =>
            !(
              this.inPublicBid &&
              this.orderInfo.openScope === projectOpenScopeDict.COMPANY.value
            ),
          elAttrs: {
            span: 2
          }
        },
        {
          label: '报名时段查看供应商参与名单',
          prop: 'isSignupShowListing',
          dictArray: isSignupShowListingDict.array,
          hideFun: () => !this.inPublicBid
        },
        {
          label: '报名审核',
          prop: 'isApproval',
          dictArray: bidRegisterAuditFlagDict.array,
          hideFun: () => !this.inPublicBid,
          elAttrs: {
            labelClassName: this.isKpbProject ? 'text-danger' : '',
            contentClassName: this.isKpbProject ? 'text-danger' : ''
          }
        },
        {
          label: '证件要求',
          prop: 'requireList',
          filter: value => {
            const certNameArray = value.map(item => item.certName)
            return certNameArray.join('，')
          },
          elAttrs: {
            span: 2
          },
          hideFun: () =>
            !this.isNeedApproval || this.orderInfo.requireList.length === 0
        },
        {
          label: '其他材料要求',
          prop: 'otherMaterialList',
          elAttrs: {
            span: 2
          },
          hideFun: () => !this.isNeedApproval,
          slotName: 'otherRequire'
        },
        {
          label: '备注',
          prop: 'approvalRemark',
          hideFun: () => !this.isNeedApproval,
          elAttrs: {
            span: 2
          }
        },
        {
          label: '联合体报名',
          prop: 'isCombo',
          dictArray: isComboDict.dictArray,
          elAttrs: {
            span: 2
          }
        },
        {
          label: '邀请供应商',
          slotName: 'inviteSupNormal',
          hideFun: () => this.inPublicBid,
          elAttrs: {
            span: 2
          }
        },
        {
          label: '内部文件',
          prop: 'internalAttachments',
          slotName: 'internalAttachments',
          elAttrs: { span: 2 }
        }
      ]
    },

    // 保证金设置
    bondInfoOptions() {
      return [
        {
          label: '是否收取保证金',
          prop: 'isCollectGuarantee',
          filter: value => needBidBondDict.translate(value).label || '-',
          elAttrs: {
            labelClassName: this.isKpbProject ? 'text-danger' : '',
            contentClassName: this.isKpbProject ? 'text-danger' : ''
          }
        },
        {
          label: '保证金收取方式',
          prop: 'collectGuaranteeMode',
          filter: value => bondBidTypeDict.translate(value).label || '-',
          hideFun: value =>
            value.isCollectGuarantee === needBidBondDict.NO.value
        },
        {
          label: '保证金金额（元）',
          prop: 'guaranteeFee',
          // filter: value => (value ? strToThousands(value) : '-'),
          slotName: 'guaranteeFee',
          hideFun: value =>
            value.isCollectGuarantee === needBidBondDict.NO.value
        },
        {
          label: '保证金缴纳截止时间',
          prop: 'depositEndTime',
          filter: value => {
            return DateUtils.getNormMinute(value)
          },
          hideFun: value =>
            value.isCollectGuarantee === needBidBondDict.NO.value ||
            value.collectGuaranteeMode !== bondBidTypeDict.PLATFORM.value
        }
      ]
    },

    // 招标文件信息
    bidFileInfoOption() {
      return [
        {
          label: '电子化开评标',
          prop: 'isKpbProject',
          dictArray: whetherDict.array,
          elAttrs: {
            labelClassName: this.isKpbProject ? 'text-danger' : '',
            contentClassName: this.isKpbProject ? 'text-danger' : ''
          }
        },
        {
          label: '招标文件',
          prop: 'isReissueFile',
          dictArray: uploadBiddingFileTypeDict.array,
          hideFun: () => this.isKpbProject
        },
        {
          label: '标书费',
          prop: 'bookFee',
          slotName: 'bookFee',
          elAttrs: {
            span: 2,
            labelClassName: this.isKpbProject ? 'text-danger' : '',
            contentClassName: this.isKpbProject ? 'text-danger' : ''
          }
        },
        {
          label: '平台使用费',
          prop: 'platformFee',
          slotName: 'platformFee',
          elAttrs: {
            span: 2,
            labelClassName: this.isKpbProject ? 'text-danger' : '',
            contentClassName: this.isKpbProject ? 'text-danger' : ''
          },
          hideFun: () =>
            this.orderInfo.platformFee === null ||
            this.orderInfo.platformFee === '' ||
            this.orderInfo.platformFee === undefined
        },
        {
          label: '上传文件',
          prop: 'biddingAttachmentIds',
          slotName: 'biddingAttachmentIds',
          hideFun: () => this.isKpbProject,
          elAttrs: {
            span: 2
          }
        },
        {
          label: this.isKpbProject ? '其它文件(图纸)' : '其他文件',
          prop: 'otherAttachment',
          slotName: 'otherAttachment',
          elAttrs: {
            span: 2
          }
        }
      ]
    },

    // 公告内容
    biddingNoticeOption() {
      return [
        {
          label: '发布日期',
          prop: 'noticeReleaseTime',
          isNormDay: true
        }
      ]
    }
  },

  watch: {
    'requestQuery.orderId': {
      handler: function(val) {
        this.orderId = val
        if (this.isByOrderId && val) {
          this.getInviteBidInfo()
        }
      },
      immediate: true
    }
  },

  methods: {
    strToThousands,
    /**
     * 获取招标单详情
     */
    async getInviteBidInfo() {
      try {
        const _data = await fetchInviteBidDetailApi({ orderId: this.orderId })
        this.orderInfo = _data.data || {}
        this.bondInfo = _data.data.guarantee || {}
        this.orderInfo.biddingAttachmentIds =
          this.orderInfo.biddingAttachmentIds &&
          this.orderInfo.biddingAttachmentIds.length
            ? this.orderInfo.biddingAttachmentIds.join(',')
            : ''
        this.orderInfo.otherAttachmentIds =
          this.orderInfo.otherAttachmentIds &&
          this.orderInfo.otherAttachmentIds.length
            ? this.orderInfo.otherAttachmentIds.join(',')
            : ''
        if (this.orderInfo.projectId) {
          this.getProjectInfo()
        }
      } catch (error) {
        this.$message.error(error.message || '获取招标单信息失败')
      }
    },

    /**
     * 获取委托项目详情
     */
    async getProjectInfo() {
      try {
        const _data = await getEntrustInfoByOrderIdApi(this.orderId)
        this.projectInfo = _data.data || {}
      } catch (error) {
        this.$message.error(error.message)
      }
    },

    /**
     * 定向公开范围供应商输入字段转换
     */
    normalizeInGroup(list) {
      return list.map(tag => {
        return {
          categoryType: tag.categoryType,
          categoryId: tag.categoryId,
          name: tag.categoryName
        }
      })
    },

    normalizeIn(list) {
      return list.map(tag => {
        return {
          companyId: tag.supplierId,
          companyName: tag.supplierName,
          contactTel: tag.contactUserPhone,
          contactName: tag.contactUserName,
          comboCompanyNames: tag.comboCompanyNames
        }
      })
    },

    // 供应商列表弹窗组件数据传出前的数据转换
    normalizeOut(list) {
      return list.map(tag => {
        return {
          supplierId: tag.companyId,
          supplierName: tag.companyName,
          contactUserPhone: tag.contactTel,
          contactUserName: tag.contactName,
          comboCompanyNames: tag.comboCompanyNames
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.no-file-tip {
  color: $second-text-color;
}
.notice-section {
  background-color: $info-sixth-color;
  border-radius: 2px;
  padding: 14px;
  border: 1px solid $border-color;
  h5 {
    font-size: 14px;
    margin-block-start: 0em;
    margin-block-end: 0em;
    text-align: center;
    padding-bottom: 14px;
    @include text-bold;
    font-weight: 500;
  }
}
.online-file_inbox {
  width: 100%;
  background-color: $info-sixth-color;
  padding: 14px;
  border: 1px solid $dividing-color;
}
</style>
